module.exports = new __parcel__URL__("news_1.846cef25.jpg").toString();